import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-602ffd95")

_pushScopeId("data-v-602ffd95")
const _hoisted_1 = { class: "space-y-6 ml-4" }
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_4 = { class: "space-y-6 ml-4" }
const _hoisted_5 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_6 = { class: "pr-6 ml-4" }
const _hoisted_7 = {
  key: 0,
  class: "detail-cargo-detail handover-detail-table"
}
const _hoisted_8 = { class: "flex flex-col items-start" }
const _hoisted_9 = {
  key: 0,
  class: "text-black-lp-300 underline text-12px font-semibold mt-1 cursor-pointer"
}
const _hoisted_10 = {
  key: 1,
  class: "text-center text-black-lp-300 py-6"
}
const _hoisted_11 = {
  key: 1,
  class: "detail-cargo-detail handover-detail-table"
}
const _hoisted_12 = {
  key: 1,
  class: "text-center text-black-lp-300 py-6"
}
const _hoisted_13 = {
  key: 0,
  class: "flex items-center justify-between pb-3"
}
const _hoisted_14 = { class: "text-black-lp-300 font-semibold text-14px" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.title,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Title, {
            label: _ctx.$t('handover.detail.sectionDelivery')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('handover.detail.partnerName'),
              value: _ctx.detailData.handoverPartnerName
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2 capitalize",
              label: _ctx.$t('handover.detail.userType'),
              value: _ctx.partnerType
            }, null, 8, ["label", "value"])
          ])
        ]),
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Title, {
            label: _ctx.$t('handover.detail.sectionStt')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('handover.detail.totalStt'),
              value: _ctx.detailData.handoverManifestTotalStt
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('handover.detail.totalPieces'),
              value: _ctx.detailData.handoverTotalPiece
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('handover.detail.totalGrossWeight'),
              value: _ctx.formatWeight(_ctx.detailData.handoverManifestTotalGrossWeight)
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('handover.detail.totalVolumeWeight'),
              value: _ctx.formatWeight(_ctx.detailData.handoverManifestTotalVolumeWeight)
            }, null, 8, ["label", "value"])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Tabs, {
            modelValue: _ctx.activeSttTab,
            "onUpdate:modelValue": _ctx.onChangeSttTab,
            data: _ctx.sttTabs,
            rounded: false,
            marginTop: 0,
            marginBottom: 0
          }, null, 8, ["modelValue", "onUpdate:modelValue", "data"])
        ]),
        (_ctx.activeSttTab === 'success')
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              (_ctx.successStt.length)
                ? (_openBlock(), _createBlock(_component_TableV2, {
                    key: 0,
                    data: _ctx.successStt,
                    columns: _ctx.columns,
                    pagination: _ctx.pagination,
                    hidePagination: "",
                    borderTop: false,
                    isSpaceTop: false
                  }, {
                    statusHitApi: _withId(({ item }) => [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", {
                          innerHTML: _ctx.renderApiStatusBadge(item)
                        }, null, 8, ["innerHTML"]),
                        (_ctx.isApiStatusFailed(item))
                          ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_9, [
                              _createTextVNode(_toDisplayString(_ctx.$t("handover.list.detail.viewReason")), 1)
                            ], 512)), [
                              [
                                _directive_tooltip,
                                _ctx.renderApiStatusTooltip(item),
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["data", "columns", "pagination"]))
                : (_openBlock(), _createBlock("div", _hoisted_10, "-"))
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_11, [
              (_ctx.failedSttList.length)
                ? (_openBlock(), _createBlock(_component_TableV2, {
                    key: 0,
                    data: _ctx.failedSttList,
                    columns: _ctx.failedSttColumns,
                    pagination: _ctx.pagination,
                    hidePagination: "",
                    borderTop: false,
                    isSpaceTop: false
                  }, null, 8, ["data", "columns", "pagination"]))
                : (_openBlock(), _createBlock("div", _hoisted_12, "-"))
            ]))
      ]),
      "sub-data": _withId(() => [
        (_ctx.handoverStatusBadgeHtml)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("handover.list.detail.handoverStatus")), 1),
              _createVNode("div", { innerHTML: _ctx.handoverStatusBadgeHtml }, null, 8, ["innerHTML"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('handover.detail.createdAt'),
          value: _ctx.formatDate(_ctx.detailData.handoverCreatedAt),
          caption: _ctx.detailData.handoverCreatedBy
        }, null, 8, ["label", "value", "caption"]),
        (_ctx.showRetryButton)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 1,
              onClick: _ctx.onClickRetry,
              class: "mt-3 w-full",
              iconLeft: "reload-white",
              sizeIcon: "w-4",
              title: _ctx.$t('handover.list.retry.menu'),
              textColor: "white",
              fontWeight: "semibold",
              color: "red-lp-100"
            }, null, 8, ["onClick", "title"]))
          : _createCommentVNode("", true),
        _hoisted_15,
        (_ctx.detailData.handoverStatus !== 'FAILED')
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 2,
              label: _ctx.$t('handover.detail.printHandover')
            }, {
              default: _withId(() => [
                _createVNode(_component_LpButton, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.print('summary'))),
                  class: "mt-3 w-48",
                  flat: "",
                  dense: "",
                  iconLeft: "print-summary",
                  title: _ctx.$t('handover.detail.printSummary'),
                  iconV2: true,
                  color: "gray-lp-600"
                }, null, 8, ["title"]),
                _createVNode(_component_LpButton, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.print('basic'))),
                  class: "w-48",
                  flat: "",
                  iconLeft: "printer",
                  dense: "",
                  title: _ctx.$t('handover.detail.printPdf'),
                  iconV2: true,
                  color: "gray-lp-600"
                }, null, 8, ["title"]),
                (_ctx.showPrintVendorReceipt)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      onClick: _ctx.printVendorReceipt,
                      class: "w-48",
                      flat: "",
                      iconLeft: "printer",
                      dense: "",
                      title: _ctx.$t('handover.detail.printResiVendor'),
                      iconV2: true,
                      color: "gray-lp-600"
                    }, null, 8, ["onClick", "title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType"]),
    (_ctx.showRetryModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.closeRetryModal,
          onClose: _ctx.closeRetryModal,
          title: _ctx.$t('handover.list.retry.processTitle'),
          message: _ctx.$t('handover.list.retry.processBody', { n: _ctx.retryProcessCount }),
          image: "print-label-pending",
          textSuccess: _ctx.$t('handover.list.retry.processOk'),
          class: "px-8",
          "data-testid": "handover-detail-retry-process-modal",
          color: "red-lp-2400"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess"]))
      : _createCommentVNode("", true)
  ], 64))
})